import React, {Component, createRef} from "react";
import classNames from 'classnames';
import styles from './FJBackgroundMoreList.module.less';
import FJToolContent from 'fj-components/FJToolContent'
import FJPageHeaderBack from 'fj-components/FJPageHeaderBack'
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJCustomScroll from 'fj-components/FJCustomScroll';
import FJFixedLayout from 'fj-components/FJFixedLayout';
import FJResourceBackgroundCommon from 'fj-components/FJBackgroundColorContainer/FJResourceBackgroundCommon';
import FJResourceMediaCommon from 'fj-components/FJMediaContainer/FJResourceMediaCommon';
import FJLocalStore from "../../../store/FJLocalStore";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJMediaItemPlaceholder from "./FJMediaItemPlaceholder";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJSearchLoading from "./FJSearchLoading";

class FJBackgroundMoreList extends Component {

  constructor(props) {
    super(props);

    this.scrollRef = createRef();
  }

  componentDidMount() {
    this.scrollRef.current && this.scrollRef.current.scrollTop(0, true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {isShow, expandData, nextPage} = this.props;
    if (isShow && (isShow !== prevProps.isShow) && expandData.status !== FJViewConstant.STOCK_SEARCH_SUBLOADING
      && expandData.type === 'video') {
      this.scrollRef.current.scrollTop(0, true);
      let scroll = this.scrollRef.current.getScroll();
      if (scroll.current.getScrollHeight() === scroll.current.getClientHeight()) {
        nextPage(expandData.title);
      }
    }
  }

  _getCollectionList = () => {
    let {
      resourceViewInfo,
      expandData,
      onAddClick,
      onMediaDrag,
      classes,
      config,
      allTooltip,
      toggleTooltip,
      oneTooltip,
    } = this.props;

    let {
      width,
      height,
      space,
      marginBottom,
      marginTop,
      marginLeft = 0
    } = resourceViewInfo;

    let {addIcon, addIconToolTip} = config;
    let {list} = expandData;

    return <FJFixedLayout
      basicWidth={width}
      space={space}
      active={list.length}
      render={(itemWidth, space, column) => {
        return list.map((data, index) => {
          let subProps = {
            key: index,
            id: data.id,
            selectMedia: () => {
            },
            width: width,
            height: height,
            marginRight: (index + 1) % column === 0 ? 0 : space,
            marginBottom: marginBottom,
            marginTop: marginTop,
            type: data.type,
            onAddClick: onAddClick,
            classes: classes.itemClasses,
            addIcon: addIcon,
            onMediaDrag: onMediaDrag,
            addIconToolTip: addIconToolTip,
            allTooltip: allTooltip,
            toggleTooltip: toggleTooltip,
            oneTooltip: oneTooltip,
            marginLeft: marginLeft,
          };
          if (data.type === FJCoreConstant.BACKGROUND) {
            return (
              <FJResourceBackgroundCommon {...{
                ...subProps,
                id: data.color,
                color: data.color,
                hasTime: true,
              }}  />
            );
          } else {
            return (
              data.status === 'placeholder' ? <FJMediaItemPlaceholder/> :
                <FJResourceMediaCommon {...{
                  ...subProps,
                  status: data.status,
                  thumbnail: data.thumbnail,
                  url: data.url,
                  fromType: data.fromType,
                  duration: data.duration,
                }}  />
            );
          }
        });
      }}
    />
  }

  onPageHeaderClick = () => {
    if (this.props.backElement) {
      this.props.backElement();
    }
  }

  onScroll = (event) => {
    FJCoreUtil.triggerBodyMousedown()
    const {nextPage, expandData} = this.props;
    const {scrollTop, clientHeight, scrollHeight} = event.target;
    if (scrollTop + clientHeight === scrollHeight && nextPage && expandData.type === 'video') {
      nextPage(expandData.title);
    }
  };

  render() {

    const {
      isShow,
      backTitle,
      classes,
      expandData,
    } = this.props;

    const {list, title, status, total} = expandData;

    let cn = classNames(styles.more_box, isShow ? 'show' : 'hide');

    return (
      <div className={cn}>
        <FJToolContent active={isShow}>
          <FJPageHeaderBack onClick={this.onPageHeaderClick}
                            backText={backTitle}
                            title={title}
                            classes={classes.pageHeaderBackClasses}
          >
            <div className={styles.list_box}>
              <FJCustomScroll ref={this.scrollRef}
                              classes={classes.scrollClasses}
                              onScroll={this.onScroll}>
                <div className={styles.inner}>
                  {
                    this._getCollectionList()
                  }
                  {
                    total === list.length && <div className={styles.tip}>{FJLocalStore._('end-list')}</div>
                  }
                  {
                    status === FJViewConstant.STOCK_SEARCH_SUBLOADING && <FJSearchLoading style={{
                      height: '76px',
                    }} active/>
                  }
                </div>
              </FJCustomScroll>
            </div>
          </FJPageHeaderBack>
        </FJToolContent>
      </div>
    )
  }

}


export default FJBackgroundMoreList;